import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import { ShippingLine } from '../../../models/ShippingLine';
import { ErpNfe } from '../../../models/ErpNfe';
import { ErpOrder } from '../../../models/ErpOrder';
import { Carrier } from '../../../models/Carrier';
import { CarrierStatusTracking } from '../../../models/CarrierStatusTracking';
import { Fulfillment } from '../../../models/Fulfillment';
import { GetOrderAddressesOutput } from '../../../services/Orders/GetOrderAddresses/GetOrderAddressesOutput';
import { CardCollectTracking } from '../CardCollectTracking/CardCollectTracking';
import {
  Container, HeaderContainer, ShippingLineCarrier,
  CarrierIdentification, ShippingLineNumber,
  CarrierChangeButton, BodyContainer
} from './styles';
import { useAuth } from '../../../contexts/AuthContext';
import { SessionHelper } from '../../../helpers/SessionHelper';


interface ICardShippingLineProps {
  orderNumber?: string;
  shippingLine: ShippingLine;
  shippingLineNumber: number;
  erpOrderList?: ErpOrder[];
  orderAddresses?: GetOrderAddressesOutput | null;
  carrierList?: Carrier[];
  carrierStatusTrackingList?: CarrierStatusTracking[];
  changeCarrier?: (shippingLineId: number) => void;
  manuallyCollect?: (getNfe: boolean) => void;
  changeTrackingCode?: (collectTrackingItemId: number, trackingCode: string) => void;
  fulfillments?: Fulfillment[];
}

const CardShippingLine: React.FC<ICardShippingLineProps> = ({
  orderNumber,
  shippingLine,
  shippingLineNumber,
  erpOrderList,
  orderAddresses,
  carrierList,
  carrierStatusTrackingList,
  changeCarrier,
  manuallyCollect,
  changeTrackingCode,
  fulfillments
}) => {

  const { session } = useAuth();
  const userCanManageTransport = SessionHelper.canManageTransport(session);

  const numberOfCollect = shippingLine?.collectTrackingList?.length || 0;

  const getNfes = () => {
    let nfes: ErpNfe[] = [];
    if (numberOfCollect > 0) {
      erpOrderList?.forEach(erpOrder => {
        if (erpOrder.erpNfes) {
          nfes = [...nfes, ...erpOrder.erpNfes];
        }
      });
    }
    return nfes;
  }

  const body = numberOfCollect > 0 ? (
    shippingLine?.collectTrackingList?.map(collectTracking => (
      <CardCollectTracking
        key={`collect-tracking-${collectTracking.id}`}
        orderNumber={orderNumber}
        shippingLineCode={shippingLine.code}
        collectTracking={collectTracking}
        nfes={getNfes()}
        erpOrderList={erpOrderList}
        orderAddresses={orderAddresses}
        carrier={carrierList?.find(c => c.code === shippingLine.code)}
        carrierStatusTrackingList={carrierStatusTrackingList}
        manuallyCollect={manuallyCollect}
        changeTrackingCode={changeTrackingCode}
        fulfillments={fulfillments}
      />
    ))
  ) : (
    <div>Nenhuma coleta virtual realizada até o momento.</div>
  );

  return (
    <Container key={`shipping-line-${shippingLine.id}`}>
      <HeaderContainer>
        <ShippingLineNumber>
          Linha de Transporte {shippingLineNumber}
        </ShippingLineNumber>
        <ShippingLineCarrier>
          <CarrierIdentification>
            {(shippingLine.title?.length > 30 ? shippingLine.title.substring(0, 30) + '...' : shippingLine.title) + ' (' + shippingLine.code + ')'}
          </CarrierIdentification>
          {userCanManageTransport && changeCarrier && (
            <CarrierChangeButton title='Trocar Transportadora' onClick={() => changeCarrier && changeCarrier(shippingLine.id)}>
              <FontAwesomeIcon icon={faExchangeAlt} color='#c26c0a' size='1x' />
            </CarrierChangeButton>
          )}
        </ShippingLineCarrier>
      </HeaderContainer>
      <BodyContainer>
        {body}
      </BodyContainer>
    </Container>
  );
}

export { CardShippingLine };